export default {
      id: "bi-usage",
      viewBox: "0 0 51 49",
      url: __webpack_public_path__ + "sprite-46b249.svg#bi-usage",
      toString: function () {
        return this.url;
      }
    }